import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { Controller } from "react-hook-form";

export const Textarea = ({
  name,
  label,
  disabled,
  control,
  required,
  defaultValue,
  className = "",
}) => (
  <Controller
    rules={{ required }}
    name={name}
    control={control}
    render={({ field: { onChange, value } }) => (
      <FormGroup className={`${className} p-0`}>
        {label && (
          <Label for={name} disabled={disabled}>
            {label}
            {required && <span className="text-danger">*</span>}
          </Label>
        )}
        <Input
          type="textarea"
          disabled={disabled}
          onChange={onChange}
          value={value}
          defaultValue={defaultValue}
        />
      </FormGroup>
    )}
  />
);
